/**
 * Carries a renter's opaque UI settings bag on proto.
 */
export class ProtoUserAppSettingsDto {
  id!: number;
  userId!: number;
  settingsValues!: Record<string, unknown>;
}
